import _ from "lodash";
import { toast } from "react-toastify";

export const rowPerPage = 50;
export const antTableScroll = { x: true };
export const addFormType = "Add";
export const editFormType = "Edit";

export const transactionTypeList = [
  { id: "All", title: "Select All" },
  { id: "0", title: "Pending" },
  { id: "1", title: "Success" },
  { id: "2", title: "Failed" },
  { id: "3", title: "Refund" },
];

export const getTodayDate = () => {
  // Create a new Date object for the current time
  // const now = new Date();
  // // Adjust the time for IST (+05:30)
  // const istOffset = 5.5 * 60; // IST offset in minutes
  // const localOffset = now.getTimezoneOffset(); // Local timezone offset in minutes
  // const offsetInMinutes = istOffset - localOffset;
  // now.setMinutes(now.getMinutes() + offsetInMinutes);
  // const date = now.toISOString().split("T")[0];

  const date = new Date().toISOString().split("T")[0];
  return date;
};

export const baseB4Key = "data:image/jpeg;base64,";

export const noImage = "../assets/images/no-image.jpg";

export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

async function handleAllImagesUpLoad(file) {
  const base64 = await convertToBase64(file);
  // console.log("base64---", base64);
  const base642 = base64.split(",");
  return base642[1];
}
export default handleAllImagesUpLoad;

export const urlForInputFile = (file) => URL.createObjectURL(file);

export function splitImageBaseData(data) {
  const base642 = data.split(",");
  return base642[1];
}

export const templateDefault = "DEFAULT";
export const templateOne = "TEMPLATE1";
export const templateTwo = "TEMPLATE2";
export const templateThree = "TEMPLATE3";

export const defaultSiteLogo = "assets/images/logo.png";
export const defaultSiteName = "Pay Fazz pvt ltd";
export const defaultSiteAddress =
  "E-309, 702, 703, CRYSTAL PLAZA, OPP. INFINITY MALL, NEW LINK RD, ANDHERI WEST,MUMBAI";
export const defaultSiteContact = "9205844811,9205844822,9205844833";
export const defaultSiteMail = "support@payfazz.in";
export const defaultSiteColor = "#fff";
export const defaultMenuColor = "#0a165e";
export const defaultButtonColor = "#9e2a96";
export const defaultDashboardMenuColor = "#000";
export const defaultDashboardButtonColor = "#6f0d5b";

export const adminRole = 1;

export const consoleEnableKey = "CONSOLE_ENABLE";
export const appConfigKey = [
  "LOGIN_ENABLE",
  consoleEnableKey,
  "FUNDTRANSFER_TIME",
  "LOGIN_TIME",
  "TWO_FACTOR_AUTHENTICATE",
  "SMS_ENABLE",
  "SMS_SEND_USER_DETAILS",
  "SMS_TRANSACTION_MESSAGE",
  "SMS_RECHARGE_MESSAGE",
  "SMS_MODE_ENABLE",
  "MOBILE_NO_LOGIN",
  "LIEN_AMOUNT",
  "UNDER_MAINTENANCE",
  'Scheduler',
  "INSTANT_PG_CREDIT_TO_MAINWALLET",
  "AUTO_PG_TO_MAIN_WALLET_TRANSFER_REQUEST",
  "TRANSACTION_STATUS_CHECK_DELAY",
];

export const popButtonDefaultIcon = (
  <i className="bi bi-question-circle-fill fs-4 me-2 text-warning" />
);
export const popButtonDefaultTitile = "Confirmation";
export const popButtonDefaultDesc = (val = "") =>
  `Are you sure to ${val || "perform this action"}.`;
export const popButtonStatusIcon = (
  <i className="bi bi-exclamation-circle-fill fs-4 me-2 text-warning" />
);
export const popButtonStatusTitile = "Change Status";
export const popButtonStatusDesc = (val = "") =>
  `Are you sure to change ${val || "this data"} status.`;
export const popButtonDeleteIcon = (
  <i className="bi bi-question-circle-fill fs-4 me-2 text-warning" />
);
export const popButtonDeleteTitile = "Delete data";
export const popButtonDeleteDesc = (val = "") =>
  `Are you sure to delete ${val || "this data"}.`;

export const ellipsisLast = (data, limit = 1, fromWhere = "last") => {
  if (data && data.length > limit) {
    if (fromWhere === "last") {
      return `${data.substring(0, limit)}...`;
    }
    if (fromWhere === "start") {
      return `...${data.substring(data.length - limit, limit)}`;
    }
  }
  return data;
};

export const ellipsisButtonTitle = "View More";

export const InputNumberOnlyValidation = (Item, setValue) => {
  const value = Item;
  // Regex Syntax: Allows numbers and a single optional decimal point
  if (/^\d*\.?\d*$/.test(value)) {
    setValue(value);
    if (value > 0 || value === "") {
      // Allows Positive numbers only
      setValue(value);
    } else {
      toast.error("Negative Amount Not Acceptable");
    }
  } else {
    toast.error("Number ONLY");
  }
};

export const allOperatorTypeList = [
  { key: 1, id: "Broadband Postpaid", title: "Broadband Postpaid" },
  { key: 2, id: "Cable", title: "Cable" },
  { key: 3, id: "Clubs and Association", title: "Clubs and Association" },
  { key: 4, id: "Credit Card", title: "Credit Card" },
  { key: 5, id: "DTH", title: "DTH" },
  { key: 6, id: "Education", title: "Education" },
  { key: 7, id: "Electricity", title: "Electricity" },
  { key: 8, id: "FASTag Recharge", title: "FASTag Recharge" },
  { key: 9, id: "Gas-Pipeline", title: "Gas-Pipeline" },
  { key: 10, id: "Hospital", title: "Hospital" },
  { key: 11, id: "Housing Society", title: "Housing Society" },
  { key: 12, id: "Insurance", title: "Insurance (Life, General, Health & Others)" },
  { key: 13, id: "Landline Postpaid", title: "Landline Postpaid" },
  { key: 14, id: "Loan Repayments", title: "Loan Repayments" },
  { key: 15, id: "LPG Gas", title: "LPG Gas" },
  { key: 16, id: "Mobile PostPaid", title: "Mobile PostPaid" },
  { key: 17, id: "Municipal Taxes & Services", title: "Municipal Taxes & Services" },
  { key: 18, id: "Recurring Deposits", title: "Recurring Deposits" },
  { key: 19, id: "Subscription", title: "Subscription" },
  { key: 20, id: "Water", title: "Water" },
  { key: 21, id: "Mobile Prepaid", title: "Mobile Prepaid" },
  { key: 22, id: "Donation", title: "Donation" },
  { key: 23, id: "Rental", title: "Rental" },
]

export const userRoleList = {
  1: 'Admin',
  2: 'Employee',
  3: 'Master Distributor',
  4: 'Super Distributor',
  5: 'Distributor',
  6: 'Retailer',
}

export const ticketTypeKey = "TICKETTYPE";
export const ticketCategoryKey = "TICKETCATEGORY";
export const ticketSubjectKey = "TICKETSUBJECT";
export const ticketProjectKey = "TICKETPROJECT";
export const byMeKey = "By Me";

export const ticketStatusList = [
  { id: 0, value: 0, title: "Pending", label: "Pending" },
  { id: 1, value: 1, title: "Resolved", label: "Resolved" },
  { id: 2, value: 2, title: "InProgress", label: "InProgress" },
  { id: 3, value: 3, title: "Hold", label: "Hold" },
  { id: 4, value: 4, title: "Reject", label: "Reject" },
  { id: 5, value: 5, title: "In Client Review", label: "In Client Review" },
  // {id: 5, title: 'Cancel'},
];
export const base64Key = "data:image/jpeg;base64,";
export const apiDocKeysList = [
  "APIDOC_RechargeAccess",
  "APIDOC_BillPayAccess",
  "APIDOC_PayoutAccess",
  "APIDOC_UPIPayoutAccess",
  "APIDOC_CreditCard",
  // "apidoC_PayIn"
  "APIDOC_PayIn",
];

export const roleList = {
  0: "User",
  1: "Admin",
  2: "Business",
  3: "Master Distributor",
  4: "Super Distributor",
  5: "Distributor",
  6: "Retailer",
  7: "Employee",
};
export const requestToListByRole = (currentUser) => {
  let list = [{ key: 0, value: 1, label: "Admin" }];
  if (!_.isEmpty(currentUser) && !_.isEmpty(currentUser.fundtransferSeniorDetailsList)) {
    _.map(currentUser.fundtransferSeniorDetailsList, (val, ind) => {
      if ((_.toNumber(currentUser.role) - 1) === _.toNumber(val.role)) {
        list.push({
          key: ind + 1, value: val.userID, label: userRoleList[_.toNumber(val.role)]
        })
      }
    })
    // if (currentUser.role === "4") {
    //   list = [...list, { key: 2, value: 3, label: "Master Distributor" }];
    // }
    // if (_.toNumber(currentUser.role) === 5) {
    //   list = [
    //     ...list,
    //     // { key: 2, value: 3, label: "Master Distributor" },
    //     { key: 3, value: currentUser.senior_ID, label: "Super Distributor" },
    //   ];
    // }
    // if (_.toNumber(currentUser.role) === 6) {
    //   list = [
    //     ...list,
    //     // { key: 2, value: 3, label: "Master Distributor" },
    //     // { key: 3, value: 4, label: "Super Distributor" },
    //     { key: 4, value: currentUser.senior_ID, label: "Distributor" },
    //   ];
    // }
  }
  return list;
};